import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import React from 'react'
import styled from 'styled-components'
import Modal from 'styled-react-modal'

const StyledModal = Modal.styled({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  backgroundColor: 'white',
  padding: '30px',
  margin: '20px',
})

const StyledParagraph = styled.p`
  color: ${({ theme }) => theme.colors.grayscale.black};
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;
  white-space: pre-wrap;
`

interface PolicyModalProps {
  isOpen: boolean
  toggleModal: () => void
}

const PolicyModal: React.FC<PolicyModalProps> = ({ isOpen, toggleModal, children }) => {
  return (
    <StyledModal isOpen={isOpen} onBackgroundClick={toggleModal} onEscapeKeydown={toggleModal}>
      <StyledParagraph>{children}</StyledParagraph>
      <SecondaryButton text="Close" onClick={toggleModal} />
    </StyledModal>
  )
}

export default PolicyModal
